import { render, staticRenderFns } from "./AccessControls.vue?vue&type=template&id=70c99819&scoped=true"
import script from "./AccessControls.vue?vue&type=script&lang=js"
export * from "./AccessControls.vue?vue&type=script&lang=js"
import style0 from "./AccessControls.vue?vue&type=style&index=0&id=70c99819&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c99819",
  null
  
)

export default component.exports